import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=0b3c7a28&"
import script from "./Jobs.vue?vue&type=script&setup=true&lang=js&"
export * from "./Jobs.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports